/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrerrorcorrectionlogohint4Inputs */

const en_qrerrorcorrectionlogohint4 = /** @type {(inputs: Qrerrorcorrectionlogohint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With a logo the maximum error correction is applied automatically so the code stays readable despite the covered center.`)
};

const de_qrerrorcorrectionlogohint4 = /** @type {(inputs: Qrerrorcorrectionlogohint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Logo wird automatisch die maximale Fehlerkorrektur verwendet, damit der Code trotz verdeckter Mitte lesbar bleibt.`)
};

/**
* | output |
* | --- |
* | "With a logo the maximum error correction is applied automatically so the code stays readable despite the covered center." |
*
* @param {Qrerrorcorrectionlogohint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrerrorcorrectionlogohint4 = /** @type {((inputs?: Qrerrorcorrectionlogohint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrerrorcorrectionlogohint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrerrorcorrectionlogohint4(inputs)
	return de_qrerrorcorrectionlogohint4(inputs)
});
export { qrerrorcorrectionlogohint4 as "qrErrorCorrectionLogoHint" }